import { call, put, select } from 'redux-saga/effects';
import { activeUserCountUpdated } from 'features/toolbar/toolbarSlice';
import { selectAvailableUserIds } from 'features/users/usersSlice';
import { selectSIPUserIds } from 'features/sip/sipSlice';
import { UserId } from 'features/users/types';
import { RoomStatus } from 'features/room/types';
import { selectRoomStatus } from 'features/room/roomSlice';
import { countVisibleUsersSaga } from 'features/users/sagas/countVisibleUsersSaga';

export function* updateToolbarUserCountSaga() {
  const roomStatus: RoomStatus = yield select(selectRoomStatus);
  if (roomStatus !== 'joined') {
    // don't count outside the room
    return;
  }

  const availableUserIds: UserId[] = yield select(selectAvailableUserIds);
  const sipUserIds: UserId[] = yield select(selectSIPUserIds);

  const visibleUsersCount: number = yield call(countVisibleUsersSaga, availableUserIds);

  // SIP users are always counted (they don't have roles)
  const totalCount = visibleUsersCount + sipUserIds.length;

  yield put(activeUserCountUpdated(totalCount));
}
